module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"다른 리뷰 작성하기","expected_reward":"최대 {0} 적립 가능"}}')
  delete Component.options._Ctor
}
